/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_TitleInputs */

const en_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align Left`)
};

const fr_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner a Gauche`)
};

const de_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linksbündig ausrichten`)
};

const it_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea a sinistra`)
};

const ru_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выровнять по левому краю`)
};

const es_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear a la izquierda`)
};

const zh_cn2_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左对齐`)
};

const ja_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左揃え`)
};

const hi_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाईं ओर संरेखित करें`)
};

const pt_pt2_align_left_title = /** @type {(inputs: Align_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhar à esquerda`)
};

/**
* | output |
* | --- |
* | "Align Left" |
*
* @param {Align_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_title = /** @type {((inputs?: Align_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_left_title(inputs)
	if (locale === "de") return de_align_left_title(inputs)
	if (locale === "it") return it_align_left_title(inputs)
	if (locale === "ru") return ru_align_left_title(inputs)
	if (locale === "es") return es_align_left_title(inputs)
	if (locale === "zh-CN") return zh_cn2_align_left_title(inputs)
	if (locale === "ja") return ja_align_left_title(inputs)
	if (locale === "hi") return hi_align_left_title(inputs)
	if (locale === "pt-PT") return pt_pt2_align_left_title(inputs)
	return en_align_left_title(inputs)
});